/*
 * UI/UX改善: 信頼バッジ・パートナーロゴセクション
 * Mobile: バッジサイズ縮小、余白調整
 */

import { motion } from "framer-motion";
import {
  Shield,
  Award,
  Building2,
  Landmark,
  BadgeCheck,
  Cpu,
  Cloud,
  Users,
} from "lucide-react";

const BADGES = [
  { icon: Cloud, label: "Google Workspace", sub: "認定パートナー連携" },
  { icon: Building2, label: "東洋電設株式会社", sub: "技術パートナー" },
  { icon: Cpu, label: "Google Antigravity", sub: "公式対応" },
  { icon: Shield, label: "Gemini API", sub: "統合開発" },
  { icon: Landmark, label: "人材開発支援助成金", sub: "活用実績多数" },
  { icon: Award, label: "IT導入補助金", sub: "認定支援" },
  { icon: BadgeCheck, label: "デジタル化・AI補助金", sub: "対応済" },
  { icon: Users, label: "広島商工会議所", sub: "連携" },
];

function BadgeCard({ badge }: { badge: (typeof BADGES)[0] }) {
  const Icon = badge.icon;
  return (
    <div className="flex items-center gap-2 sm:gap-3 px-3 sm:px-5 py-2 sm:py-3 bg-white border border-[#E0E0E0] rounded-sm shrink-0 hover:border-[#E03030] transition-colors duration-300">
      <Icon size={16} strokeWidth={1.5} className="text-[#E03030] shrink-0 sm:hidden" />
      <Icon size={20} strokeWidth={1.5} className="text-[#E03030] shrink-0 hidden sm:block" />
      <div className="whitespace-nowrap">
        <div className="text-xs sm:text-sm font-bold text-[#1A1A1A]">{badge.label}</div>
        <div className="text-[9px] sm:text-[10px] text-[#666666]">{badge.sub}</div>
      </div>
    </div>
  );
}

export function TrustBadgesSection() {
  // Duplicate for seamless loop
  const allBadges = [...BADGES, ...BADGES];

  return (
    <section className="py-6 sm:py-8 lg:py-10 bg-[#F9F9F9] border-b border-[#E0E0E0] overflow-hidden">
      <div className="container mb-3 sm:mb-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex items-center gap-3 mb-2"
        >
          <span className="text-[9px] sm:text-[10px] font-medium tracking-widest uppercase text-[#666666]" style={{ fontFamily: "'Inter', sans-serif" }}>
            Trusted By & Partners
          </span>
          <div className="flex-1 h-px bg-[#E0E0E0]" />
        </motion.div>
      </div>

      {/* Marquee */}
      <div className="relative">
        {/* Gradient fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-8 sm:w-16 bg-gradient-to-r from-[#F9F9F9] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-8 sm:w-16 bg-gradient-to-l from-[#F9F9F9] to-transparent z-10 pointer-events-none" />

        <motion.div
          className="flex gap-3 sm:gap-4"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear",
            },
          }}
        >
          {allBadges.map((badge, i) => (
            <BadgeCard key={`${badge.label}-${i}`} badge={badge} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
